<div class="spinner-border my-3" [ngClass]="color ? 'text-' + color : 'text-dark'" role="status">
    <span class="visually-hidden">جاري التحميل...</span>
</div>